import {QueryCommand, GoingUtils, AssertUtils} from "goingutils";
import EditorTypeUtils, {getEditorType} from "../../common/editorTypeUtils";


function __getRowStyle(rowIndex) {
    if (rowIndex > 0) {
        return ``;
    }
}

//显示校验错误信息
function _showValidationError(inputId) {
    $(`#${inputId}`)
        .parent()
        .find(".error-info")
        .show();
    $(`#${inputId}`)
        .parent()
        .find(".clear-icon")
        .hide();
    $(`#${inputId}`).addClass("error-input");
}

class GoingForm {
    constructor(formType, _prefixCls, queryBtnFlag) {
        //form类型 主要是分查询和编辑类型
        this.formType = formType;
        this.colWidth = null;
        //form的前缀 编码form的id重复
        this.prefixCls = _prefixCls || GoingUtils.getUUid(12);
        this.changeEvent = {};
        //查询按钮标志
        this.queryBtnFlag = queryBtnFlag;
        //需要初始化表单才行
        EditorTypeUtils.initGoForm();
    }

    destructor() {
        this.prefixCls = null;
        this.changeEvent = null;
        this.fieldAry = null;
        this.inputWidth = null;
        this.labelWidth = null;
        this.rowsLength = null;
        this.queryBtnFlag = null;
    }

    //初始化表单
    initForm({
                 fieldAry,
                 colNum = 4,
                 colWidth,
                 labelWidth = "auto",
                 inputWidth = "auto"
             }) {
        //列基数
        this.colNum = colNum;
        this.colWidth = colWidth;
        //编辑状态不为false的字段 才进入form
        this.fieldAry = fieldAry.filter(function (itemObj) {
            return itemObj.editor != false;
        });

        //对fieldAry进行排序  需要将hidden字段放到后面去
        this.fieldAry=this.initFieldAryOrder(this.fieldAry);

        //label的宽度
        this.labelWidth = labelWidth;
        this.inputWidth = inputWidth;
        //如果需要查询按钮 则将放到最后一列
        if (this.queryBtnFlag) {
            this.fieldAry.push({type: "queryFormBtns"});
        }
        this.rowsLength = Math.ceil(fieldAry.length / colNum);
    }

    //对fieldAry进行排序  需要将hidden字段放到后面去
    initFieldAryOrder(fieldAry){
        let newFieldAry=[];let hidenAry=[];
        fieldAry.forEach(function (item) {
            if(item.type==='hidden'){
                hidenAry.push(item);
            }else{
                newFieldAry.push((item));
            }
        })
        return [...newFieldAry,...hidenAry];
    }

    //清空占位列
    clearSlotItem(ctlId) {
        let formObj = this;
        //用于实现占多列的布局
        $("#" + ctlId)
            .find(".slotEl")
            .each(function () {
                let fieldId = $(this).attr("fieldId");
                let elOb = $(this)
                    .closest(".ivu-row")
                    .find(`#${formObj.prefixCls}_${fieldId}`);
                //如果元素存在
                if (AssertUtils.isNotNull(elOb.get(0))) {
                    let className = elOb.closest(".ivu-col").attr("class");
                    className = className.replace("ivu-col ivu-col-span-", "");
                    let classNumber = parseFloat(className) + 6;
                    elOb
                        .closest(".ivu-col")
                        .attr("class", "ivu-col ivu-col-span-" + classNumber);
                    $(this)
                        .parent()
                        .remove();
                } else {
                    $(this)
                        .parent()
                        .remove();
                }
            });
    }

    //获取一行对应的html代码
    getRowHtml(rowIndex) {
        let rowItems = [];
        let colNum = 24 / this.colNum;
        if(this.colNum===5){
            colNum='4_5';
        }
        for (
            let num = rowIndex * this.colNum;
            num < rowIndex * this.colNum + this.colNum;
            num++
        ) {
            if (this.fieldAry[num] != null) {
                //如果存在change事件 则进行注册
                if (this.fieldAry[num]["change"] != null) {
                    this.changeEvent[this.prefixCls + "_" + this.fieldAry[num]["id"]] = this.fieldAry[num]["change"];
                }
                //如果用户没有定义某一项的输入宽度，则采用
                if (!AssertUtils.isNotNull(this.fieldAry[num]["inputWidth"])) {
                    this.fieldAry[num]["inputWidth"] = this.inputWidth;
                }
                rowItems.push(this.fieldAry[num]);
            }
        }

        let rowHtmls = [
            `<div class="ivu-row go-form-row" style="${__getRowStyle(rowIndex)}">`
        ];
        //循环行数来获取html代码
        for (let rowIndex = 0; rowIndex < rowItems.length; rowIndex++) {
            //如果列宽传入了数组 才需要这么操作
            if (AssertUtils.isNotEmpty(this.colWidth) && AssertUtils.isArray(this.colWidth)) {
                if (this.colWidth[rowIndex] === '*') {
                    rowHtmls.push(`<div class="ivu-col pull-left">`);
                } else {
                    rowHtmls.push(`<div class="ivu-col pull-left" style="width: ${this.colWidth[rowIndex]}px">`);
                }
            } else {
                rowHtmls.push(`<div class="ivu-col ivu-col-span-${colNum}">`);
            }
            let item = rowItems[rowIndex];
            if (this.formType === "query") {
                item["defVal"] = "";
                item["treeRelVal"] = "";
            }

            if (item.type === "queryFormBtns") {
                //如果是查询按钮
                rowHtmls.push(this.getQueryBtnsHtml());
            } else {
                //如果form的输入元素
                rowHtmls.push(this.getRowItemHtml(item));
            }
            rowHtmls.push(`</div>`);
        }
        rowHtmls.push(`</div>`);
        return rowHtmls.join("");
    }

    /**
     * 获取查询按钮集合
     * @returns {*}
     */
    getQueryBtnsHtml() {
        return `<div style="padding-left: 35px;">
            <a  href="javascript:void(0)" class="common_button common_button_gray margin_t_10">清除</a>
            <a  href="javascript:void(0)" class="common_button common_button_emphasize  margin_t_10 margin_r_10" style="margin-left:6px;">查询</a>
        </div>`;
    }

    //获取一行html代码
    getRowItemHtml(item) {
        return EditorTypeUtils.getItemHtmlByType(item, this.formType, this);
    }

    /**
     * 获取某项的值
     * @param item
     * @returns {*}
     */
    getItemValue(item) {
        let backJson = {};
        let objForm = this;
        EditorTypeUtils.initGoForm();
        let editorType = getEditorType(item);
        let object = EditorTypeUtils.getObj(editorType);

        if (object != null) {
            object.getSubmitData(item, objForm, backJson, objForm.formType);
        }
        return (backJson)[item["id"]];
    }

    /**
     * 校验表单
     * @param item
     * @returns {*}
     */
    validationForm() {
        let requiredAry = [];
        let backFlag = true;
        let goingForm = this;
        let numberAry = [];
        let dateAry = [];
        //循环获取required校验的选项
        this.fieldAry.forEach(function (item) {
            let {required,  validate, editorType} = item;
            if (required) {
                requiredAry.push(item);
            }
            if (editorType === "number") {
                numberAry.push(item);
            }
            if (AssertUtils.isNotNull(validate)) {
                validate.forEach(function ({type}) {
                    //如果类型是数字
                    if (type === "number") {
                        numberAry.push(item);
                    }
                    //如果类型是日期
                    if (type === "date") {
                        dateAry.push(item);
                    }
                });
            }
        });
        //校验必输
        requiredAry.forEach(function (item) {
            let inputElId = `${goingForm.prefixCls}_${item["id"]}`;
            //如果输入值为空 则提醒
            if (!AssertUtils.isNotEmpty(goingForm.getItemValue(item))) {
                backFlag = false;
                $(`#${inputElId}`)
                    .parent()
                    .find(".error-info")
                    .attr("msg", "【" + item["label"] + "】不能为空");
                _showValidationError(inputElId);
            }
        });

        //数字校验
        numberAry.forEach(function (item) {

            let inputElId = `${goingForm.prefixCls}_${item["id"]}`;
            //如果不是number
            if(!AssertUtils.isNumber(goingForm.getItemValue(item))){
                backFlag = false;
                $(`#${inputElId}`)
                    .parent()
                    .find(".error-info")
                    .attr("msg", `${item["label"]}输入的不是有效数字！`);
                _showValidationError(inputElId);
            }
            //最小值校验
            let minVal = item.minVal;
            if(minVal!=null&&(goingForm.getItemValue(item)<minVal)){
                backFlag = false;
                $(`#${inputElId}`)
                    .parent()
                    .find(".error-info")
                    .attr("msg", `${item["label"]}输入的值小于最小值${item.minVal}！`);
                _showValidationError(inputElId);
            }
            //最大值校验
            let maxVal=item.maxVal;
            if(maxVal!=null&&(goingForm.getItemValue(item)>maxVal)){
                backFlag = false;
                $(`#${inputElId}`)
                    .parent()
                    .find(".error-info")
                    .attr("msg", `${item["label"]}输入的值大于最大值${item.minVal}！`);
                _showValidationError(inputElId);
            }

        });
        //日期校验
        dateAry.forEach(function (item) {
            backFlag = false;
            let inputElId = `${goingForm.prefixCls}_${item["id"]}`;
            $(`#${inputElId}`)
                .parent()
                .find(".error-info")
                .attr("msg", `${item["label"]}输入的不是有效日期！`);
            _showValidationError(inputElId);
        });
        //email的校验
        dateAry.forEach(function (item) {
            backFlag = false;
            let inputElId = `${goingForm.prefixCls}_${item["id"]}`;
            $(`#${inputElId}`)
                .parent()
                .find(".error-info")
                .attr("msg", `${item["label"]}输入的不是有效邮箱！`);
            _showValidationError(inputElId);
        });
        return backFlag;
    }

    //获取form的html内容输出
    html() {
        let htmls = [];
        for (let index = 0; index < this.rowsLength; index++) {
            htmls.push(this.getRowHtml(index));
        }
        return htmls.join("");
    }

    //获取form需要提交的数据
    getSubmitData(recordId) {
        let backJson = {};
        let objForm = this;
        this.fieldAry.forEach(function (item) {
            EditorTypeUtils.getSubmitDataByItem(
                item,
                backJson,
                objForm.formType,
                objForm
            );
        });
        if (AssertUtils.isNotNull(recordId)) {
            (backJson)["id"] = recordId;
        }
        return backJson;
    }

    //设置某些字段disabled
    setDisabled(elAry, flag) {
        let goingForm = this;
        if (AssertUtils.isArray(elAry)) {
            if (!flag) {
                elAry.forEach(function (item) {
                    let inputElId = `${goingForm.prefixCls}_${item}`;
                    ($(`#${inputElId}`))
                        .attr("disabled", false)
                        .removeClass("input-disabled");
                });
            } else {
                elAry.forEach(function (item) {
                    let inputElId = `${goingForm.prefixCls}_${item}`;
                    ($(`#${inputElId}`))
                        .attr("disabled", true)
                        .addClass("input-disabled");
                });
            }
        }
    }

    //情况form里面的值
    clearData() {
        let objForm = this;
        this.fieldAry.forEach(function (item) {
            EditorTypeUtils.clearData(item, objForm.formType, objForm);
        });
    }

    //设置所有自动不可以操作
    setAllDisabled() {
    }

    //设置某个字段的值
    setValue(elId, elValue) {
        var targetObj = this;
        let item = (EditorTypeUtils.itemTemp)[
            `${targetObj.prefixCls}_${elId}`
            ];
        //如果不为空 才继续执行
        if (AssertUtils.isNotNull(item)) {
            let editorType = getEditorType(item);
            let object = EditorTypeUtils.getObj(editorType);
            if (object != null) {
                object.setValue(elId, elValue, item, targetObj);
            }
        }
    }

    //获取数据根据url
    loadDataByUrl(url, params = {}) {
        let formObj = this;
        let queryCommand = new QueryCommand(url);
        queryCommand.executeQuery(
            params,
            function (backData) {
                if (backData != null && backData.length > 0) {
                    let jsonData = {...backData[0]};
                    EditorTypeUtils.loadDataByJson(jsonData, formObj);
                }
            },
            null,
            "json"
        );
    }

    //设置数据 根据传入的json格式的data
    loadDataByJson(jsonData) {
        EditorTypeUtils.loadDataByJson(jsonData, this);
    }

    //执行事件
    executeEvent(eventName, elId, elVal, vueObj) {
        let changeFun = this.changeEvent[elId];
        if (AssertUtils.isFunction(changeFun)) {
            changeFun(this, {vueObj, elId, elVal});
        }
    }
}

export default GoingForm;



// WEBPACK FOOTER //
// ./goingsrc/jsCom/comCtl/goingForm.js